import { useLocation, useNavigate } from 'react-router-dom';
import { appStyles, logoImage } from './app.style'
import { ContainerApp, ContentApp, HeaderApp } from './Layout.app';

interface MenuOption {
	label: string;
	action: () => void;
}

const generateMenuOptions = (hayPendientes: boolean, hayTurnosPasados: boolean, navigate: Function) => {

	const menuOptions: MenuOption[] = [
		{
			label: 'Solicitar Turno Nuevo',
			action: () => {navigate('/app/wizard')}
			// action: () => {navigate('/app/wizard?noBack=true')}
		},
	]

	if (hayPendientes) menuOptions.push({
		label: 'Turnos Pendientes',
		action: () => {navigate('/app/turnos-pendientes')}
	})
	if (hayTurnosPasados) menuOptions.push({
		label: 'Turnos Pasados',
		action: () => {navigate('/app/turnos-pasados')}
	})

	menuOptions.push({
		label: 'Mis Datos',
		action: () => {navigate('/app/perfil')}
	})

	menuOptions.push({
		label: 'Cambiar Pin',
		action: () => {navigate('/app/change-pass')}
	})

	menuOptions.push({
		label: 'Pedir Ayuda',
		action: () => {navigate('/app/ayuda')}
	})

	menuOptions.push({
		label: 'Salir de Kaiteki',
		action: () => {navigate('/app/login')}
	})

	return menuOptions;
}

export const MenuApp = () => {
	const navigate = useNavigate()


	const { hayPendientes, hayTurnosPasados } = useLocation()?.state || { 
		hayPendientes: true, 
		hayTurnosPasados: true 
	} as { 
		hayPendientes: boolean, 
		hayTurnosPasados: boolean 
	};

	const menuOptions = generateMenuOptions(hayPendientes, hayTurnosPasados, navigate);

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
	}

	return (
		<ContainerApp>
			<HeaderApp title="Menú" />
			<ContentApp>
				{menuOptions.map((option) => (
					<button 
						type="submit" 
						onClick={option.action}
						style={{...appStyles.button, marginBottom: '20px'}}
					>
						{option.label}
					</button>
				))}
			</ContentApp>
		</ContainerApp>
	)
}